import { bindable, bindingMode, computedFrom } from 'aurelia-framework';

export class PaymentMethodTypes {
	@bindable({ defaultBindingMode: bindingMode.oneWay }) paymentMethodTypeOptions: any;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) selectedPaymentMethodType: any;
	paymentMethods: any;

	constructor() {
		this.paymentMethods = this.getPaymentMethods();
	}

	getPaymentMethods() {
		return [
			{ name: 'wallet', value: 0, enabled: true, label: 'Wallet' },
			{ name: 'card', value: 1, enabled: true, label: 'Card' },
			{ name: 'ach', value: 2, enabled: true, label: 'E-Check' }
		];
	}

	@computedFrom('paymentMethodTypeOptions')
	get paymentMethodTypes() {
		try {
			if (!this.paymentMethodTypeOptions)
				return this.paymentMethods;

			this.paymentMethods[0].enabled = this.paymentMethodTypeOptions.showWallet;
			this.paymentMethods[1].enabled = this.paymentMethodTypeOptions.showCard;
			this.paymentMethods[2].enabled = this.paymentMethodTypeOptions.showAch;

			if (this.paymentMethodTypeOptions.walletLabel)
				this.paymentMethods[0].label = this.paymentMethodTypeOptions.walletLabel;

			if (this.paymentMethodTypeOptions.cardLabel)
				this.paymentMethods[1].label = this.paymentMethodTypeOptions.cardLabel;

			if (this.paymentMethodTypeOptions.achLabel)
				this.paymentMethods[2].label = this.paymentMethodTypeOptions.achLabel;

			return this.paymentMethods;
		}
		catch (err) {
			return this.paymentMethods;
		}
	}
}
